import { useQuery } from '@tanstack/react-query'
import * as R from 'remeda'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { applyOr, filterExists } from '~/utils'

import { useMainQueryKey } from './useMainQueryKey'

const document = graphql(`
  query BrandAccountsListPage_Main {
    brandAccounts {
      id
      name
      partnerSeat {
        total
        used
      }
      userSeat {
        total
        used
      }
    }
  }
`)

export const useMainQuery = () => {
  const queryKey = useMainQueryKey()
  const graphQLRequest = useGraphQLRequest()

  return useQuery({
    queryFn: async () => {
      const result = await graphQLRequest({ document })

      return R.pipe(result.brandAccounts, applyOr(filterExists, []))
    },
    queryKey,
  })
}

export type BrandAccount = NonNullable<
  QueryResultOf<typeof useMainQuery>
>[number]
